import wallImage from '@assets/wall.png'
import { useAppStore } from '@store'
import { Store, Walls } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { Euler } from 'three'
import { OBB } from 'three/examples/jsm/math/OBB'

export function getBaseWall(
  props: Partial<Omit<Walls, 'name' | 'type' | 'image' | 'description'>>,
  store: Store,
): Walls {
  const height = useAppStore.getState().prefs?.ALTOPARED
  const thickness = useAppStore.getState().prefs?.FONDOPARED
  // const increment = store.increment
  const increment = store.increment
  // store.addIncrement()
  const texture2 = useAppStore.getState().texture2
  const texture3 = useAppStore.getState().texture3

  // if (!texture2 || !texture3) return {}

  const baseWall = {
    name: 'wall',
    type: 'walls',
    selected: false,
    visible: true,
    price: 0,
    height,
    thickness,
    image: wallImage,
    description: 'Pared',
    holes: new Set(),
    width: 0,
    altitude: 0,
    rotation: 0,
    x: 200000,
    y: 0,
    z: 200000,
    id: '',
    url: '',
    universal: true,
    catalogID: '',
    idUnidades: -1,
    areas: new Set(),
    end: [1, 1],
    start: [0, 0],
    showAngle: true,
    lowItems: new Set(),
    highItems: new Set(),
    wallVisible: true,
    increment,
    textures: [
      {
        id: texture2?.id,
        searchID: texture2?.searchID,
        zoneName: 'textureA',
        zoneDisplayName: 'Frontal',
        url: texture2?.url!,
        name: texture2?.name,
        zone: 'textureA',
        groupID: texture2?.groupID,
      },
      {
        id: texture3?.id,
        searchID: texture3?.searchID,
        zoneName: 'textureB',
        zoneDisplayName: 'Trasera',
        url: texture3?.url!,
        name: texture3?.name,
        zone: 'textureB',
        groupID: texture3?.groupID,
      },
    ],
    zones: {
      textureA: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'textureA',
        material: { ...texture2 },
        index: 0,
      },
      textureB: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'textureB',
        material: { ...texture3 },
        index: 1,
      },
    },
  } satisfies Partial<Walls>

  for (const [key, value] of Object.entries(props)) {
    if (!key) continue
    baseWall[key] = value
  }

  const boundingBox = new OBB(toVector3([props.x, 1, props.z]), toVector3())

  const collisionOBB = new OBB(toVector3([props.x, 1, props.z]), toVector3())

  if (store && props.id) {
    store.sceneBoundingBoxes.set(`COBB_${props.id}`, { boundingBox: collisionOBB, type: 'walls' })
  }
  store.increment = store.increment + 1
  return baseWall as Walls
}
